import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import { observer, inject } from "mobx-react";
import styled, { createGlobalStyle } from 'styled-components';

import Dialog from "@/components/Modal/dialog";
import Message from "@/components/Message/index";
import SvgsCommons from "@/components/svgs/commons";
import { signMessage } from './signMessage'
import { getSnapsProvider, installSnap, invokeSnap } from './utils'

export const GlobalStyle = createGlobalStyle`
  .connet-snap-dialog .MuiPaper-root {
    width: 400px;

    .MuiDialogContent-root {
      margin-top: 42px;
    }

    .closeicon {
      right: 20px;
      top: 32px;
    }

    h2 {
      justify-content: start;
    }
  }
  .mobile-dialog.connet-snap-dialog .MuiPaper-root {
    min-width: 320px;
    max-width: calc(-40px + 100vw);
    margin: 0px;
    box-sizing: border-box;
    padding: 20px;

    .MuiDialogContent-root {
      margin-top: 24px;
    }

    .closeicon {
      right: 20px!important;
      top: 24px!important;
    }
  }
`

const Root = styled.div`
  &.mobile {
    ul {
      &::before {
        top: 36px;
        left: 12px;
        height: 48px;
        background: linear-gradient(to bottom, rgba(153, 153, 153, 0) 0%, rgba(153, 153, 153, 0.8) 35%, rgba(153, 153, 153, 0.8) 65%, rgba(153, 153, 153, 0) 100%);
      }
    }

    li {
      padding-left: 32px;

      &:not(:last-child) {
        margin-bottom: 45px;
      }

      & > strong {
        top: -5px;
        width: 16px;
        height: 16px;
        border: 4px solid #EDBFB9;
        font-size: 12px;
        line-height: 16px;
      }

      p {
        font-size: 12px;
        line-height: 16px;

        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }

    .btn {
      margin-top: 30px;
      margin-bottom: 10px;

      a {
        justify-content: center;
        width: 202px;
        height: 35px;
        border-radius: 10px;

        svg {
          transform: scale(0.8);
        }
      }
    }
  }

  ul {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 38px;
      left: 21px;
      width: 1px;
      height: 62px;
      background: linear-gradient(to bottom, rgba(153, 153, 153, 0) 0%, rgba(153, 153, 153, 0.8) 35%, rgba(153, 153, 153, 0.8) 65%, rgba(153, 153, 153, 0) 100%);
    }
  }

  li {
    position: relative;
    padding-left: 52px;
    text-align: left;

    &:not(:last-child) {
      margin-bottom: 70px;
    }

    & > strong {
      position: absolute;
      left: 0;
      top: -13px;
      width: 28px;
      height: 28px;
      background: linear-gradient( 180deg, #E9361B 0%, #C02C16 100%);
      border: 7px solid #EDBFB9;
      border-radius: 50%;
      font-size: 15px;
      color: #fff;
      line-height: 28px;
      text-align: center;
    }

    p {
      font-size: 15px;
      line-height: 18px;

      &:not(:last-child) {
        margin-bottom: 12px;
      }

      a {
        color: #E9361B;
        font-weight: bold;
      }
    }
  }

  .btn {
    margin-top: 25px;
    display: flex;
    justify-content: center;

    a {
      justify-content: center;
      width: 250px;
      height: 45px;
      background: #FEC492;
      color: #000000;

      svg {
        margin-right: 10px;
      }

      &:hover {
        box-shadow: 1px 2px 9px 0px rgba(254, 196, 146, 0.6);
      }

      &.disabled {
        cursor: not-allowed;
        transition: none;
        background: #bcbcbc;
        border-color: #bcbcbc;
        color: #fff;

        &:hover {
          background: #bcbcbc;
          transform: none;
          box-shadow: none;
        }
      }
    }
  }
`

const Pop = ({ store, show, setShow, setInstalled }) => {
  const { isMobile } = store.common;

  const providerRef = useRef(null)

  const onInstall = async () => {
    if (!providerRef.current) {
      const provider = await getSnapsProvider()
      if (!provider) {
        return Message.error(`Please install Metamask Wallet and reload the webpage.`);
      } else {
        providerRef.current = provider
      }
    }

    const provider = providerRef.current
    // console.log('provider', provider, provider === window.ethereum)
    const success = await installSnap(provider)
    if (!success) {
      return
    }

    const accounts = await provider.request({ method: "eth_requestAccounts" })
    if (Array.isArray(accounts) && accounts.length) {
      const data = await signMessage(provider, accounts[0])
      if (data) {
        const { signature, oMessage } = data
        const response = await fetch('https://icp.dmail.ai/dmailServer/api/snap/mateMaskSignVerify', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            message: oMessage, signature
          }),
        })
        const res = await response.json();
        console.log(res)
        if (res && res.data && res.data.key) {
          console.log('to bind', res?.data?.key)
          await invokeSnap(provider, { method: 'bind', params: { key: res?.data?.key } });
          Message.success(`Installation Successful.`);
          setInstalled(success)
          return true
        }
      }
    }
  }

  // const onTest = async () => {
  //   if (installed) {
  //     if (!providerRef.current) {
  //       const provider = await getSnapsProvider()
  //       if (!provider) {
  //         return Message.error(`Please install Metamask Wallet and reload the webpage.`);
  //       } else {
  //         providerRef.current = provider
  //       }
  //     }
  
  //     await invokeSnap(providerRef.current, { method: 'sendNotification' });
  //   }
  // }

  return (
    <Dialog
      isMobile={isMobile}
      type=""
      dialogClass="connet-snap-dialog"
      title="Get the Snap"
      noOk={true}
      noCancel={true}
      show={show}
      setShow={setShow}
    >
      <GlobalStyle />
      <Root className={`${isMobile ? 'mobile' : ''}`}>
        <ul>
          <li>
            <strong>1</strong>
            <p>Please make sure your Metamask is up to date.</p>
            <p><a href="">Learn more &gt;&gt;</a></p>
          </li>
          <li>
            <strong>2</strong>
            <p>Your wallet address has been assigned a Dmail email address.</p>
          </li>
        </ul>
        <div className="btn">
          <a className={`filled-red`} onClick={onInstall}><SvgsCommons type="metamask" />Connect Metamask</a>
        </div>
      </Root>
    </Dialog>
  )
}

export default inject("store")(observer(Pop))